// firebase/index
export const firebaseConfig = {
  apiKey: "AIzaSyDWeY6tFwjwG6FoBq41HApKVY6Oci9j2Z4",
  authDomain: "congresovirtual-tierradelfuego.firebaseapp.com",
  projectId: "congresovirtual-tierradelfuego",
  storageBucket: "congresovirtual-tierradelfuego.appspot.com",
  messagingSenderId: "12561870893",
  appId: "1:12561870893:web:5daa94c0e0c8d97d2008a4",
  measurementId: "G-6W3DDWZW9B",
};
// firebase/storage
export const storageUrl =
  "https://firebasestorage.googleapis.com/v0/b/congresovirtual-tierradelfuego.appspot.com/o/";
